import { render, staticRenderFns } from "./focus-items-cmp.vue?vue&type=template&id=d2070c24&scoped=true"
import script from "./focus-items-cmp.vue?vue&type=script&lang=js"
export * from "./focus-items-cmp.vue?vue&type=script&lang=js"
import style0 from "./focus-items-cmp.vue?vue&type=style&index=0&id=d2070c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2070c24",
  null
  
)

export default component.exports